import { RootState } from 'shared/store/store'
import { recipientsAdapter } from './reducer'

export const getSendMessageRecipients = (state: RootState) =>
  recipientsAdapter.getSelectors().selectAll(state.sendMessage.message)
